import ErrorMessage from "./ErrorMessage";
import ErrorTarget  from "./ErrorTarget";

class Error {
  constructor(private readonly _target: ErrorTarget = new ErrorTarget(), private readonly _message: ErrorMessage = new ErrorMessage()) {
  }

  get target() {
    return this._target;
  }

  get message() {
    return this._message;
  }
}

export default Error;